import { load } from "@cashfreepayments/cashfree-js";

const mode = process.env.REACT_APP_DEPLOY_ENV === "Prod" ? "production" : "sandbox";

let cashfreeLoadPromise = null;

/** Single shared Cashfree instance (modal checkout; user stays on the page). */
export async function getCashfree() {
  if (!cashfreeLoadPromise) {
    cashfreeLoadPromise = await load({ mode });
  }
  return cashfreeLoadPromise;
}
